import { Pipe, type PipeTransform } from '@angular/core';
import { formatTimeStringDisplay } from '@principle-theorem/shared';
import { type Moment } from 'moment-timezone';

@Pipe({
  name: 'timeFormat',
})
export class TimeFormatPipe implements PipeTransform {
  transform(value: string | Moment): string {
    return formatTimeStringDisplay(value);
  }
}
